module.exports = __webpack_public_path__ + "img/map_sky-porch.b9c38afe.jpg";